import {FC} from 'react'
import {TaskModalContent} from './TaskModalContent'
import {ID} from '../../../helpers'
import {useParams} from 'react-router-dom'

type Props = {
  handleClose: () => void | undefined
  stageId: ID | string
  sprintId: ID
  initialTaskName?: string
  initialTaskDate?: string
  initialDescription?: string
  initialProjectId?: string | number
  initialPriority?: string
  initialIsPublic?: boolean
  initialAttachments?: Array<{id: number; file: string; file_name: string}>
  initialClientPortalTicketId?: number
  onTaskCreated?: (taskId: number) => void
}

const TaskModalContentWrapper: FC<Props> = ({
  handleClose, 
  stageId, 
  sprintId, 
  initialTaskName, 
  initialTaskDate,
  initialDescription,
  initialProjectId,
  initialPriority,
  initialIsPublic,
  initialAttachments,
  initialClientPortalTicketId,
  onTaskCreated,
}) => {  
    return <TaskModalContent 
      handleClose={handleClose} 
      stageId={stageId} 
      sprintId={sprintId} 
      initialTaskName={initialTaskName} 
      initialTaskDate={initialTaskDate}
      initialDescription={initialDescription}
      initialProjectId={initialProjectId}
      initialPriority={initialPriority}
      initialIsPublic={initialIsPublic}
      initialAttachments={initialAttachments}
      initialClientPortalTicketId={initialClientPortalTicketId}
      onTaskCreated={onTaskCreated}
    />
}

export {TaskModalContentWrapper}
